// List of tax codes that should default the taxable flag to false
export const NON_TAXABLE_PRODUCTS = ["txcd_00000000"];

// Default tax code for taxable items
export const DEFAULT_TAXABLE_PRODUCT = "txcd_20030000";
